import React from 'react';
import { v4 as uuidv4 } from 'uuid';
const InputSelectBox = ({errors, Label, elementName, handleRegChange, value, arrOptions, type}) => {
  return <div>
    <label htmlFor={elementName} className="block text-sm font-medium text-label-clr pl-1">
        {Label}
    </label>
      <select
        id={elementName}
        name={elementName}
        value={value !== undefined && value !== null ? value.toString() : ''}
        onChange={handleRegChange}
        className="bg-input-bg mt-1 block w-full px-3 py-3 border border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
      >
        <option value="">Select an option</option>
        {arrOptions.map((obj, index) => {
            let optionValueRaw;
            if (elementName === "EventName") optionValueRaw = obj.EventId ?? obj.Id ?? obj.id;
            else if (elementName === "EventType") optionValueRaw = obj.EventDetailsId ?? obj.EventDetailsID ?? obj.Id ?? obj.id ?? obj[type];
            else optionValueRaw = obj[type] ?? obj.value ?? obj.id ?? index;
            const optionValue = optionValueRaw !== undefined && optionValueRaw !== null ? optionValueRaw.toString() : '';
            const optionKey = optionValue || index;
            return (
              <option value={optionValue} key={optionKey} data-key={optionKey}>{obj[type]}</option>
            )
        })}
      </select>
        {errors && (
            <p className="text-red-500 text-sm mt-1">{errors}</p>
        )}
    </div>;
};

export default InputSelectBox;